
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/cookiepolitik",
      function () {
        return require("private-next-pages/[country]/[language]/cookiepolitik/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[country]/[language]/cookiepolitik"])
      });
    }
  